import { LOAD_TRACKING, TRACKING_FAILURE, TRACKING_SUCCESS } from '../actions';

const initialState = {
    fetching: false,
    error: undefined,
    tracking: {},
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_TRACKING:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case TRACKING_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case TRACKING_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                tracking: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
